<div id="page-layout" class="page-layout">
  <div
    id="navigation_wrapper"
    class="page-layout__side-wrapper"
    [class.visiblePanel]="visibleSelectPlantationPanel || notificationsDrawerVisible">
    <div class="page-layout__side-navbar">
      <app-navigation-bar
        (changeActiveMenu)="activeMenu = $event"
        (toggleNotifications)="onToggleNotifications($event)"></app-navigation-bar>
    </div>
    @if (notificationsDrawerVisible) {
      <dk-notifications
        [class.visible]="notificationsDrawerVisible"
        (mouseenter)="notificationsDrawerVisible = true"
        (mouseleave)="onNotificationsMouseLeave()"
        (popoverStateChange)="onNotificationPopoverStateChange($event)"></dk-notifications>
    } @else {
      @if (!isCSIDomain) {
        <app-plantation-select-panel
          [class.visible]="visibleSelectPlantationPanel"
          [activeMenu]="activeMenu"
          (mouseenter)="visibleSelectPlantationPanel = true"
          (selectPlantationEvent)="visibleSelectPlantationPanel = false" />
      }
    }
  </div>

  <div class="page-layout__body">
    <div class="page-layout__body-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
